import styled from 'styled-components';

export const ExampleQuestionsPanelToggleButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 0;
  border: none;
  background: none;
  color: var(--brand-primary);
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;

  .rioglyph {
    font-size: 15px;
  }

  &:hover:not([aria-disabled='true']) {
    text-decoration: underline;
  }

  &[aria-disabled='true'] {
    color: var(--gray-darker);
    cursor: not-allowed;
  }
`;
